
import { form2StatusInfoType } from '@/types/Information/Form2';
import { Component, Prop, Vue } from 'vue-property-decorator';

import StepNumber from "@/components/utils/StepNumber.vue";

@Component({
    components:{
        StepNumber
    }
})
export default class Form2ProcessHeader extends Vue {  
    
    @Prop({required: true})
    stepsCompleted!: form2StatusInfoType;

}
